import { render, staticRenderFns } from "./SwitchButton.vue?vue&type=template&id=bde01db6&scoped=true&"
import script from "./SwitchButton.vue?vue&type=script&lang=js&"
export * from "./SwitchButton.vue?vue&type=script&lang=js&"
import style0 from "./SwitchButton.vue?vue&type=style&index=0&id=bde01db6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde01db6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bde01db6')) {
      api.createRecord('bde01db6', component.options)
    } else {
      api.reload('bde01db6', component.options)
    }
    module.hot.accept("./SwitchButton.vue?vue&type=template&id=bde01db6&scoped=true&", function () {
      api.rerender('bde01db6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Rentabilidade/components/SwitchButton.vue"
export default component.exports